var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageSubjectChemistry = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 37,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.608 4.111h10.764v9.407c0 .118.02.235.06.346l5.334 14.903c.719 2.008-.77 4.122-2.903 4.122H10.117c-2.133 0-3.622-2.114-2.903-4.122l5.333-14.902c.04-.112.06-.229.06-.347V4.111Zm13.255 26.722c.71 0 1.207-.704.967-1.374l-5.333-14.902a3.084 3.084 0 0 1-.18-1.039V6.167h-6.654v7.351c0 .354-.06.706-.18 1.04L9.15 29.458c-.24.67.256 1.374.967 1.374h15.746Z",
  fill: "#FFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.313 5.139c0-.568.46-1.028 1.027-1.028h11.306a1.028 1.028 0 1 1 0 2.056H12.34c-.567 0-1.027-.46-1.027-1.028ZM22.244 28.778H13.74a1.028 1.028 0 0 1-.98-1.336l2.584-8.222c.135-.429.532-.72.98-.72h3.337c.45 0 .846.291.98.72l2.585 8.222a1.028 1.028 0 0 1-.98 1.336Z",
  fill: "#FFF"
})));
export default SvgHomepageSubjectChemistry;